import { render } from "./VehicleGroup.vue?vue&type=template&id=06ec1221&scoped=true"
import script from "./VehicleGroup.vue?vue&type=script&lang=js"
export * from "./VehicleGroup.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-06ec1221"

export default script